import { render, staticRenderFns } from "./CompanyFileBox.vue?vue&type=template&id=e1ccc662&"
import script from "./CompanyFileBox.vue?vue&type=script&lang=js&"
export * from "./CompanyFileBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports